import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=926024a2&scoped=true"
import script from "./Plugins.vue?vue&type=script&lang=ts"
export * from "./Plugins.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926024a2",
  null
  
)

export default component.exports